import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Remove the static SEO fallback tags (title/description/OG/Twitter in
// public/index.html marked data-static-seo) before React mounts. PageMeta
// (react-helmet-async) injects per-route versions; without this cleanup,
// JS-rendering crawlers see duplicated titles/descriptions on every page.
// Non-JS crawlers never run this, so they keep the static fallbacks.
document
  .querySelectorAll("[data-static-seo]")
  .forEach((el) => el.parentNode?.removeChild(el));

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
